export default __webpack_public_path__ + "static/media/pack4x.8e384917.png";